"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BottomSheet_1 = __importDefault(require("stremio/components/BottomSheet"));
var MetaPreviewSheet_less_1 = __importDefault(require("./MetaPreviewSheet.less"));
var MetaPreviewSheet = function (_a) {
    var children = _a.children, show = _a.show, onCloseRequest = _a.onCloseRequest, onExited = _a.onExited, ariaLabel = _a.ariaLabel;
    return (react_1.default.createElement(BottomSheet_1.default, { className: MetaPreviewSheet_less_1.default['sheet'], show: show, onCloseRequest: onCloseRequest, onExited: onExited, closeOnContentClick: false, closeOnOrientationChange: false, flush: true, ariaLabel: ariaLabel }, children));
};
exports.default = MetaPreviewSheet;
